import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "posRe" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", {
  class: "posAb",
  style: {"border-bottom":"1px solid #ddd","width":"180px","top":"-12px"}
}, null, -1)
const _hoisted_3 = ["id", "max", "value"]
const _hoisted_4 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      type: "range",
      id: `${_ctx.optionName}`,
      min: `0`,
      max: `${_ctx.options.length - 1}`,
      value: `${_ctx.options.findIndex(o => o.id == _ctx.defaultId)}`,
      step: "1",
      style: {"width":"180px"},
      class: _normalizeClass(`sliderRange fl ${_ctx.optionName ? _ctx.optionName : `a`}_radio pointer`),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectId && _ctx.selectId(...args)))
    }, null, 10, _hoisted_3),
    _createElementVNode("label", {
      class: "fl pointer arial fw600",
      id: `${_ctx.optionName}`,
      style: {"margin-left":"10px"}
    }, "   " + _toDisplayString(_ctx.options.find(o => o.id == _ctx.defaultId).name), 9, _hoisted_4)
  ]))
}